import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import { callFunction } from '@/lib/callableClient';

import { sensorsQueryKey } from './useSensors';

interface Payload {
  homeId: string;
  sensorId: string;
}

export default function useDeleteSensor() {
  const qc = useQueryClient();
  return useMutation<{ ok: true }, Error, Payload>({
    mutationFn: (payload) => callFunction<Payload, { ok: true }>('deleteSensorCallable', payload),
    onSuccess: (_data, vars) => {
      void qc.invalidateQueries({ queryKey: sensorsQueryKey(vars.homeId) });
      toast.success('Sensor deleted.');
    },
    onError: (err) => {
      toast.error(err.message || 'Failed to delete sensor.');
    },
  });
}
